export default "__VITE_ASSET__BThcUJp4__"